// Modules
import Common from "./modules/common";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import WooCommon from "./modules/woo-common";
import QuickCart from "./modules/quick-cart";

// Autoload modules
const modules = [Common, Header, Lightbox, WooCommon, QuickCart];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/router";

import singlePost from "./partials/single-post";
import singleProduct from "./partials/single-product";
import singleProject from "./partials/single-project";
import wooCart from "./partials/woo-cart";
import templateHome from "./partials/template-home";
import templateContacts from "./partials/template-contacts";
import templateAccount from "./partials/template-account";
import templateCheckout from "./partials/template-checkout";
import templateSearch from "./partials/template-search";
import taxProductCat from "./partials/tax-product_cat";
import templateProjectsOverview from "./partials/template-projects-overview";

// Populate Router instance with DOM routes
const routes = new Router({
  singlePost,
  singleProduct,
  singleProject,
  templateHome,
  templateContacts,
  woocommerceAccount: templateAccount,
  woocommerceCart: wooCart,
  taxProductCat,
  templateCheckout,
  templateProjectsOverview,
  templateSearch,
});

// Load Events
$(document).ready(() => routes.loadEvents());
